module.exports = __webpack_public_path__ + "img/image_product.df32759f.png";